import React from 'react';
import { TextInput } from 'ui-toolkit';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IItemProps from './IItemProps';
import SharedItemCells from './SharedItemCells';
import { IOriginationFeeOtherViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface IOriginationFeeOther
  extends IItemProps,
    IHasItemDataProps<IOriginationFeeOtherViewItem>,
    Required<IHasItemEventProps<IOriginationFeeOtherViewItem>> {}

export default class OriginationFeeOther extends React.Component<IOriginationFeeOther> {
  public render() {
    const { data, onChange, hasEditPermissions } = this.props;
    const onValueChange = createOnChangeHandlerGenerator(data, onChange)('label');

    return (
      <SharedItemCells {...this.props} readOnly={!hasEditPermissions}>
        <TextInput
          readOnly={!hasEditPermissions}
          value={data.label}
          onChange={onValueChange}
          placeholder="Origination Fee"
          debounceOnValueChange
        />
      </SharedItemCells>
    );
  }
}
